module.exports = __webpack_public_path__ + "img/az_logo@2x.b56ddca7.png";